export const EncycPartners = [
  {
    PartnerType: "Technology Partner",
    Objective:
      "Encycdata partners with broad set of technology partners, service providers and resellers across the globe to provide state of the art solutions, services and choices to our clients.",
    Partners: [
      {
        id: "1",
        Name: "Ingram Micro",
        Logo: "https://www.ingrammicro.com/Ingram/media/Global-Content/Ingram-blue-logo.svg",
        LearnMore:
          "https://corp.ingrammicro.com/en-us/solutions/technology_solutions",
        Partnership:
          "Encycdata partnered with Ingram Micro to deliver infrastructure and software solutions to clients",
        Solutions: ["Cloud", "Colloboration", "Datacenter"],
        Services: ["Cloud", "Consulting", "Software Development"],
      },
      {
        id: "2",
        Name: "Google",
        Logo: "https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png",
        LearnMore: "https://cloud.google.com/solutions",
        Partnership:
          "Encycdata partnered with Google to provide cloud software and services to clients",
        Solutions: ["GCP", "Workspace", "Colloboration"],
        Services: ["Cloud", "Consulting"],
      },
      {
        id: "3",
        Name: "Lumen",
        Logo: "https://assets.lumen.com/is/content/Lumen/Lumen-logo-R?Creativeid=dd032ee8-6530-4437-8e9d-209b357060ce",
        LearnMore: "https://www.lumen.com/en-us/home.html",
        Partnership:
          "Encycdata partnered with Lumen to provide on-prem, colocation, datacenter, edge, cloud and CDN services",
        Solutions: ["Data center", "CDN", "Colocation"],
        Services: [
          "Data center solutions",
          "Cloud",
          "Consulting",
          "Managed Services",
        ],
      },
      {
        id: "4",
        Name: "VMware",
        Logo: "https://www.vmware.com/content/dam/digitalmarketing/vmware/en/images/company/vmware-logo-grey.svg",
        LearnMore: "https://www.vmware.com",
        Partnership:
          "Encycdata partnered with vmware to provide virtualization, cloud and virtual desktop services",
        Solutions: ["Virtualization", "Hyperconverged", "cloud", "VDI"],
        Services: [
          "Hybrid Cloud",
          "Consulting",
          "Managed Services",
          "Virtual Desktop",
        ],
      },
      {
        id: "5",
        Name: "SUSE",
        Logo: "https://avatars.githubusercontent.com/u/1067733?s=200&v=4",
        LearnMore: "https://www.suse.com",
        Partnership:
          "Encycdata partnered with SUSE to provide virtualization, cloud and container solutions",
        Solutions: ["Virtualization", "Hyperconverged", "cloud", "Kubernetes"],
        Services: ["Kubernetes", "Consulting", "Rancher", "OS"],
      },
      {
        id: "6",
        Name: "NetApp",
        Logo: "https://logos-world.net/wp-content/uploads/2022/05/NetApp-Emblem.png",
        LearnMore: "https://www.netapp.com",
        Partnership:
          "Encycdata partnered with NetApp to provide Storage, cloud and container solutions",
        Solutions: ["Storage", "cloud", "Kubernetes"],
        Services: ["Kubernetes", "Consulting", "Rancher", "OS"],
      },
      {
        id: "6",
        Name: "Solarwinds",
        Logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Solarwinds.svg/512px-Solarwinds.svg.png",
        LearnMore: "https://www.solarwinds.com/",
        Partnership:
          "Encycdata partnered with Solarwinds to provide IT management and monitpring solutions",
        Solutions: ["System Management", "Observability", "ITAM"],
        Services: ["System Management", "Observability", "ITAM", "IT Security"],
      },
      {
        id: "7",
        Name: "Seceon",
        Logo: "https://www.seceon.com/wp-content/uploads/2021/07/Seceon-Logo-no-white-outline.png",
        LearnMore: "https://www.seceon.com/",
        Partnership:
          "Encycdata partnered with Seceon to provide SIEM and MSSP soltuions and services",
        Solutions: ["SIEM", "MSSP", "XDR"],
        Services: ["SIEM", "MSSP", "XDR", "Threat Management","Ransomware Detection"],
      },
    ],
    PartnerSubheading:
      "Encycdata partners with broad set of technology partners, service providers and resellers across the globe to provide state of the art solutions, services and choices to our clients.",
  },
  {
    PartnerType: "Service Delivery Partner",
    Objective:
      "Encycdata partners with service delivery partners for inhouse development and to server our customers.",
    Partners: [
      {
        id: "1",
        Name: "Samyak",
        Logo: "https://media.licdn.com/dms/image/C4D0BAQExsnPGsvhlxg/company-logo_200_200/0/1630561095286/samyak_infotech_pvt_ltd_logo?e=2147483647&v=beta&t=NBzcTiIo6O8w7ZYMC5GQVHfzShRh8nhNx8-UlzvSfm4",
        LearnMore: "https://www.samyak.com/",
        Partnership:
          "Encycdata partnered with Samyak to deliver software development and data science and AI/ML requirements",
        Solutions: ["Web Development", "App Development","Data science and AI/ML"],
        Services: ["ReactJS", "Data science", "AI/ML"],
      },
      {
        id: "2",
        Name: "InData Labs",
        Logo: "data:image/png;base64,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",
        LearnMore: "https://indatalabs.com/",
        Partnership:
          "Encycdata partnered with Samyak to develop joint solutions and provide data science and AI/ML services",
        Solutions: ["Web Development", "App Development","Data science and AI/ML"],
        Services: ["Generative AI", "Data science", "AI/ML", "Deep Learning"],
      },
      {
        id: "3",
        Name: "Geeks2Connect",
        Logo: "https://geeks2connect.com/wp-content/uploads/2022/07/logo-1@2x.png",
        LearnMore: "https://geeks2connect.com",
        Partnership:
          "Encycdata partnered with Geek2Connect to deliver web and enterprise applications",
        Solutions: ["Web Development", "App Development"],
        Services: ["ReactJS", "React Native", "Wordpress"],
      },
      {
        id: "4",
        Name: "CGT Solutions",
        Logo: "https://www.cgtsol.in/assets/images/header/logo/logo1.png",
        LearnMore: "https://www.cgtsol.in/",
        Partnership:
          "Encycdata partnered with CGT Solutions to deliver IT consulting services across technologies and industries",
        Solutions: ["Web Development", "App Development","Consulting"],
        Services: ["ReactJS", "React Native", "Consulting"],
      },
      {
        id: "5",
        Name: "Sofyte Solutions",
        Logo: "https://sofytesolutions.com/assets/sofyte_solutions_logo-661e268f.jpeg",
        LearnMore: "https://sofytesolutions.com/",
        Partnership:
          "Encycdata partnered with Sofyte Solutions to deliver IT consulting services for full stack development and services",
        Solutions: ["Web Development", "App Development"],
        Services: ["ReactJS", "React Native", "Full Stack"],
      },
      {
        id: "6",
        Name: "InNextIn",
        Logo: "https://innextin.com/assets/img/asset_main/logo.png",
        LearnMore: "https://innextin.com/",
        Partnership:
          "Encycdata partnered with InNextIn to deliver IT consulting services for data science and AI/ML and services",
        Solutions: ["Data science", "AI/ML"],
        Services: ["ReactJS", "React Native", "Full Stack"],
      },
      {
        id: "7",
        Name: "Cloud Strategic Solution",
        Logo: "https://cloudstrategicsolution.com/wp-content/uploads/2020/09/WhatsApp_Image_2023-09-08_at_6.34.58_PM__1_-removebg-preview.png",
        LearnMore: "https://cloudstrategicsolution.com/",
        Partnership:
          "Encycdata partnered with Cloud Strategic Solution to deliver IT consulting services across technologies and industries",
        Solutions: ["Software Development", "Consulting"],
        Services: ["Software Development", "Consulting"],
      },
      {
        id: "8",
        Name: "DLabs.ai",
        Logo: "https://dlabs.ai/wp-content/uploads/2021/11/logoblue2-300x52.png",
        LearnMore: "https://dlabs.ai/",
        Partnership:
          "Encycdata partnered with DLabs.ai to deliver AI/ML consulting services and projects",
        Solutions: ["AI/ML Development", "Consulting"],
        Services: ["AI/ML Development", "Consulting"],
      },
      {
        id: "9",
        Name: "Teamwin",
        Logo: "https://teamwin.in/wp-content/uploads/2023/05/Logo.png",
        LearnMore: "https://teamwin.in/",
        Partnership:
          "Encycdata partnered with Teamwin to provide managed security services, IT services and consulting",
        Solutions: ["MSSP", "Networking and Security","Consulting"],
        Services: ["MSSP","Networking and Security", "Consulting"],
      },
      {
        id: "10",
        Name: "EGlobe Infra",
        Logo: "https://egispl.com/images/logo56.jpg",
        LearnMore: "https://egispl.com/",
        Partnership:
          "Encycdata partnered with Eglobe Infra Solutions to provide managed services, Data Center & IT services and consulting",
        Solutions: ["MSP", "Networking and Security","Data center and Cloud","Consulting"],
        Services: ["MSP","Networking and Security","Data center and Cloud", "Consulting"],
      },
      {
        id: "11",
        Name: "IBST",
        Logo: "https://ibst.in/images/logo3.png",
        LearnMore: "https://ibst.in/",
        Partnership:
          "Encycdata partnered with IBST to provide IT services and consulting",
        Solutions: ["Software Development", "Consulting"],
        Services: ["Software Development", "Consulting"],
      },
      {
        id: "12",
        Name: "ForceBolt",
        Logo: "https://www.forcebolt.com/wp-content/uploads/2022/01/fb-logo.png",
        LearnMore: "https://www.forcebolt.com/",
        Partnership:
          "Encycdata partnered with ForceBolt to provide IT services and consulting",
        Solutions: ["Software Development", "Consulting"],
        Services: ["Software Development", "Consulting"],
      },
    ],
    PartnerSubheading:
      "Encycdata partners with service delivery partners for inhouse development and to serve our customers.",
  },
  {
    PartnerType: "Education Solutions Partner",
    Objective:
      "Encycdata partners with education institutions and EdTech solution providers to provide training and projects for students community and professionals along with Encycdata Bell Diary platform ",
    Partners: [
      {
        id: "1",
        Name: "CRESD",
        Logo: "https://cdn.encycdata.com/public_asset/png/encycdata/partner/admin/India/partner/template/cresd-rd-logo-f0b7c70c-e5de-48bd-991f-a419a30a29c5.png",
        LearnMore: "http://cresd.in",
        Partnership:
          "Encycdata partnered with RD Foundation to research on rural empowerment",
        Solutions: ["Rural Development", "Empowerment"],
        Services: ["Research", "Academic"],
      },
      {
        id: "2",
        Name: "Udemy",
        Logo: "https://www.udemy.com/staticx/udemy/images/v7/logo-udemy.svg",
        LearnMore: "https://www.udemy.com/",
        Partnership:
          "Encycdata partnered with Udemy to provide curated training for different technologies, business and career paths",
        Solutions: ["Training", "Certification"],
        Services: ["Training", "Certification"],
      },
    ],
    PartnerSubheading:
      "Academic research, Online education and Training providers, Universities and organizations.",
  },
  {
    PartnerType: "Event Management Partner",
    Objective:
      "Encycdata partners with Event managment and hosting providers to provide event solutions curated based on Encycdata Bell Diary platform",
    Partners: [
      {
        id: "1",
        Name: "Interprefy",
        Logo: "https://www.interprefy.com/hubfs/Interprefy_January2020/Images/interprefy-logo.svg",
        LearnMore: "https://www.interprefy.com",
        Partnership:
          "Encycdata partnered with Interprefy to provide virtual and hybrid events and interpretation services",
        Solutions: ["Virtual Events", "Interpretors"],
        Services: ["Event management", "Job Fair", "Interpretor"],
      },
    ],
    PartnerSubheading:
      "Webinar and meetings software, event management, event registration and marketing, lead generation and audience engagement.",
  },
  {
    PartnerType: "DEIB Partner",
    Objective:
      "Encycdata partners with organizations and institutions who shares common vision of rural development and empowerment",
    Partners: [
      {
        id: "1",
        Name: "CRESD",
        Logo: "https://cdn.encycdata.com/public_asset/png/encycdata/partner/admin/India/partner/template/cresd-rd-logo-f0b7c70c-e5de-48bd-991f-a419a30a29c5.png",
        LearnMore: "http://cresd.in",
        Partnership:
          "Encycdata partnered with RD Foundation to research on rural empowerment",
        Solutions: ["Rural Development", "Empowerment"],
        Services: ["Research", "Academic"],
      },
      {
        id: "2",
        Name: "futurelightafrica",
        Logo: "https://futurelightafrica.org/wp-content/uploads/2022/04/logo_87x86.png",
        LearnMore: "https://futurelightafrica.org",
        Partnership:
          "Encycdata partnered with Future Light Africa to empower education in African countries",
        Solutions: ["Rural Development", "Empowerment"],
        Services: ["Research", "Academic"],
      },
    ],
    PartnerSubheading:
      "Oganizations work towards diversity, rural and economic development.",
  },
];
